

<footer class="social-footer">
        <!--
        <div class="säätiedot">
            <a href="https://ilmatieteenlaitos.fi/">Säätiedot tarjoaa Ilmatieteenlaitos</a>
        </div>-->
        <div class="social-footer-icons">
          <ul class="menu simple">
            <li><a href="https://www.facebook.com/Sää-Tänään-103474441110556"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
            <li><a href="https://www.instagram.com/SaaTanaan"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
            <li><a href="https://twitter.com/SaaTanaan"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
           
          </ul>
        </div>
      </footer>
      
      